module.exports = __webpack_public_path__ + "static/img/Retail.d3a57ebb.png";